import { Provider } from "@redotech/redo-model/order";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getTeamProviders = {
  name: "getTeamProviders" as const,
  input: z.object({}),
  output: z.object({
    default: createEnum(Provider),
    available: z.array(createEnum(Provider)),
  }),
};
